__webpack_require__.p = "/dialogs-size-consistency/referrals-hub/";